import { EBonusMaxBet } from '@lbs/shared-rp-types'
import { FC } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { EQueryKeysConstant } from '../../constants/EQueryKeysConstant'
import { Prp2boxApiBonus } from '../../prp2boxApi'
import { CreateRpBonusPayload } from '../../prp2boxApi/bonuses'
import { WrapDrawerEditForm } from '../index'
import RpBonusFormBase from './base'
import { TRpBonusFormData } from './schema'
import { useRpBonusForm } from './useRpBonusForm'

type TRpBonusFormEditProps = {
  bonusId: string
}

const RpBonusFormEdit: FC<TRpBonusFormEditProps> = (props) => {
  const { bonusId } = props
  const queryClient = useQueryClient()

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
    control,
  } = useRpBonusForm()

  const { data: bonus } = useQuery(
    [`get rp bonus ${bonusId}`],
    async () => {
      return Prp2boxApiBonus.getById(Number(bonusId))
    },
    {
      onSuccess: (data) => {
        reset({
          name: data.name ?? '',
          min: data.min ?? 1,
          maxPayout: data.maxPayout ?? undefined,
          max: data.max ?? EBonusMaxBet.NO_LIMIT,
          payouts: data.payouts ?? [],
        })
      },
      refetchOnWindowFocus: false,
    }
  )

  const updateMutation = useMutation(
    (payload: CreateRpBonusPayload) => Prp2boxApiBonus.update(Number(bonusId), payload),
    {
      onSuccess: () => {
        toast.success('Бонус успешно обновлен')

        queryClient.invalidateQueries([EQueryKeysConstant.RP_BONUSES])
      },
    }
  )

  const handleSave = (data: TRpBonusFormData) => {
    const { maxPayout = null, payouts, ...rest } = data

    updateMutation.mutate({
      ...rest,
      maxPayout,
      payouts: payouts as any,
    })
  }

  return (
    <WrapDrawerEditForm
      title={`Редактирование бонуса ${bonus?.name}`}
      busyText=""
      isBusy={false}
      onSave={handleSubmit(handleSave)}
      isShowSaveBtn
      isShowEditBtn={false}
      isShowDeleteBtn={false}
      isShowBlockBtn={false}>
      <RpBonusFormBase register={register} errors={errors} control={control} />
    </WrapDrawerEditForm>
  )
}

export default RpBonusFormEdit
